import { render, staticRenderFns } from "./CustodyExpenseOperationsTable.vue?vue&type=template&id=05520814&"
import script from "./CustodyExpenseOperationsTable.vue?vue&type=script&lang=js&"
export * from "./CustodyExpenseOperationsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports